export default "__VITE_ASSET__CRs8RZp9__"